export default {
  title: 'Usługa rezerwacji firmy dezaktywowana',
  description: 'Usługa rezerwacji jest obecnie nieaktywna dla tej firmy. Możesz ją aktywować w sekcji Usługi.',
  button: {
    settings: 'Przejdź do Ustawień',
  },
};
